import { render, staticRenderFns } from "./authNoteDialog.vue?vue&type=template&id=478437a2&scoped=true"
import script from "./authNoteDialog.vue?vue&type=script&lang=js"
export * from "./authNoteDialog.vue?vue&type=script&lang=js"
import style0 from "./authNoteDialog.vue?vue&type=style&index=0&id=478437a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478437a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478437a2')) {
      api.createRecord('478437a2', component.options)
    } else {
      api.reload('478437a2', component.options)
    }
    module.hot.accept("./authNoteDialog.vue?vue&type=template&id=478437a2&scoped=true", function () {
      api.rerender('478437a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/baseInfo/shopManage/storeManagement/components/authNoteDialog.vue"
export default component.exports